/**
 * Movement checkpoint types.
 *
 * The original single `movement` checkpoint was split into three functionally
 * identical variants (ground / building / utility movement). Every movement
 * variant is handled the same way throughout the UI; the legacy `movement`
 * value is kept so existing checkpoints keep working.
 *
 * Chart configuration keys mirror the device type strings, so the same helper
 * covers both device types and chart-config keys.
 */
export const MOVEMENT_DEVICE_TYPES = [
  "movement",
  "ground_movement",
  "building_movement",
  "utility_movement",
] as const;

const MOVEMENT_SET = new Set<string>(MOVEMENT_DEVICE_TYPES);

/** True for any movement variant (device type or chart-config key). */
export function isMovementType(type: string | null | undefined): boolean {
  return type != null && MOVEMENT_SET.has(type);
}
